<template>
  <tr class="item" :class="rowColor">
    <td class="pl-3">
      <v-btn icon elevation="3" color="white" @click="removeItem(item.codigo)">
        <v-icon color="red">mdi-delete</v-icon>
      </v-btn>
    </td>
    <td>{{idx}}</td>
    <td class="item__description">{{ item.descripcion }}</td>
    <td class="item__amount font-weight-black">
      <input 
        v-if="item.unidad == 'kilo'" 
        type="number" 
        step="0.1" 
        @input="increaseItemQuantity(item)" 
        @change="enforceMin"
        v-model.number="cantidad" 
        :min="min"
        class="amount__input" 
      >
      <input 
        v-else 
        @input="increaseItemQuantity(item)" 
        class="amount__input" 
        type="number" 
        step="1" 
        v-model.number="cantidad" 
        :min="min"  
      >
    </td>
    <td class="item__price">${{ formatDecimal(item.precio) }}</td>
    <td class="item__total font-weight-black"> 
      <v-chip>
        $ {{total}}
      </v-chip>
    </td>
  </tr>
</template>

<script>
import { mapActions } from 'vuex';
import {formatDecimal} from '../../services/utils';
//placed in the window object by the preload and available in the global context
// const {getCategoriaByID} = api.services.categoriasService;
export default {
  name: 'BillItem',
  data(){
    return{
      minimum: 1,
    };
  },
  props: ['item','idx'],
  methods: {
    ...mapActions(['removeItem', 'increaseItemQuantity']),
    enforceMin(){
      const item = Object.assign({},this.item);
      const isMoreThanMin = item.cantidad >= this.min;
      this.cantidad =  isMoreThanMin ? item.cantidad : this.min;
      this.item.total = this.cantidad * item.precio;
    },
    getItemMin(){
      const item = Object.assign({},this.item);
      this.min = item.minimo;
    },
    formatDecimal(num){
      return formatDecimal(num);
    }
  },
  computed: {
    rowColor(){
      return this.idx % 2 === 0 ? 'item--pair' : 'item--odd';
    },
    min: {
      get: function(){ return this.minimum; },
      set: function(num){ this.minimum = num; }
    },
    cantidad: {
      get: function(){ 
        const item = Object.assign({},this.item);
        return item.cantidad;
      },
      set: function(num){ 
        if (typeof num == 'number') this.item.cantidad = num; 
      },
    },
    total(){
      const item = Object.assign({},this.item);
      return formatDecimal(item.total);
    }
  },
  beforeMount(){
    this.getItemMin();
  }
}
</script>

<style lang="scss">
  .item{
    &--pair{
      background-color: rgb(250, 249, 249);
    }
    &__description{
      width: 100%;
    }

    &__amount{
      max-width: 70px;
    }
    &__price,
    &__total{
      text-align: right;
    }
    .amount__input{
      max-width: 100%;
    }
  }
  
  

</style>